import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rastrear-protocolo-page',
  templateUrl: './rastrear-protocolo-page.component.html',
  styleUrls: ['./rastrear-protocolo-page.component.css']
})
export class RastrearProtocoloPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    
  }

}
